var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"float"},[_c('pre',{staticStyle:{"font":"'tahoma'","font-size":"12px"},domProps:{"innerHTML":_vm._s(_vm.$globalData.data.pengumuman1)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }